<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <h6 class="mb-0">Ventas</h6>
              <button
                type="button"
                class="btn btn-primary mb-0"
                :disabled="generatingDispatch || selectedIds.length === 0"
                @click="generateDispatchReport"
              >
                <i :class="generatingDispatch ? 'fas fa-spinner fa-spin me-1' : 'fas fa-file-pdf me-1'"></i>
                Generar relación de despacho
                <span v-if="selectedIds.length" class="badge bg-light text-dark ms-1">{{ selectedIds.length }}</span>
              </button>
            </div>

            <div class="row">
              <!-- Columna de búsqueda -->
              <div class="col-md-3 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input type="text" v-model="searchQuery" id="searchQuery" class="form-control"
                  placeholder="Nombre, teléfono, ID o guía..." @input="applyFilters" />
              </div>
              <!-- Filtro por estado de pedido -->
              <div class="col-md-3 mb-3">
                <label for="orderStatusFilter" class="mb-1">Estado de pedido</label>
                <select id="orderStatusFilter" v-model="orderStatusFilter" class="form-select" @change="applyFilters">
                  <option value="">Todos</option>
                  <option v-for="s in orderStatusOptions" :key="s.value" :value="s.value">{{ s.label }}</option>
                </select>
              </div>
              <!-- Fecha inicio -->
              <div class="col-md-2 mb-3">
                <label for="dateFrom" class="mb-1">Fecha inicio</label>
                <input type="date" id="dateFrom" v-model="dateFrom" class="form-control" @change="applyFilters" />
              </div>
              <!-- Fecha fin -->
              <div class="col-md-2 mb-3">
                <label for="dateTo" class="mb-1">Fecha fin</label>
                <input type="date" id="dateTo" v-model="dateTo" class="form-control" @change="applyFilters" />
              </div>
              <!-- Limpiar filtros -->
              <div class="col-md-2 mb-3 d-flex align-items-end">
                <button type="button" class="btn btn-outline-secondary w-100 mb-0" @click="clearFilters">
                  <i class="fas fa-eraser me-1"></i> Limpiar filtros
                </button>
              </div>
            </div>

          </div>

          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">
              <table class="table align-items-center mb-0 remissions-table">
                <thead>
                  <tr>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      <input
                        type="checkbox"
                        :checked="allSelected"
                        :indeterminate.prop="someSelected"
                        @change="toggleSelectAll($event.target.checked)"
                        title="Seleccionar todas las órdenes visibles"
                      />
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">ID Mistock</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cliente</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Ciudad</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Teléfono</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Método de pago</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Vendedor</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Transportadora</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Costo de envío</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado del pedido envío</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Número de guía</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado del pedido</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Pauta</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Observación</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Monto de la venta</th>
                    <th v-if="showSiigo" class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Siigo</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <td class="align-middle text-center">
                      <input
                        type="checkbox"
                        :value="value.id"
                        v-model="selectedIds"
                      />
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ formatDateTime(value.created_at) }}
                      </span>
                    </td>
                    <td class="align-middle">
                      <router-link
                        :to="{ name: 'Remissions Picking', query: { id: String(value.id) } }"
                        class="mb-0 text-sm font-weight-bold text-primary"
                        title="Ir al picking del pedido"
                      >
                        {{ value.id }}
                      </router-link>
                      <br>
                      <span class="text-xxs text-secondary">{{ formatDate(value.created_at) }}</span>
                    </td>
                    <td class="align-middle">
                      <div class="d-flex flex-column justify-content-center">
                        <h6 class="mb-0 text-sm">{{ value.name }}</h6>
                        <span
                          v-if="saleOrigin(value)"
                          class="text-xs text-secondary origin-cell"
                          :title="saleOrigin(value)"
                        >
                          {{ saleOrigin(value) }}
                        </span>
                      </div>
                    </td>
                    <td class="align-middle">
                      <span class="text-xs font-weight-bold">{{ value.municipio || '—' }}</span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-xs font-weight-bold">{{ value.phone || '—' }}</span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-xs font-weight-bold">{{ value.payment_method || '—' }}</span>
                    </td>
                    <td class="align-middle">
                      <span class="text-xs font-weight-bold">{{ sellerName(value) }}</span>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-xs font-weight-bold">{{ value.carrier_name || '—' }}</span>
                    </td>
                    <td class="align-middle text-center text-nowrap">
                      <div class="text-xs font-weight-bold" title="Flete cobrado al cliente">
                        Flete: {{ formatMoney(fleteOf(value)) }}
                      </div>
                      <template v-if="hasShippingCost(value)">
                        <div class="text-xxs text-secondary" title="Costo de la guía en ConEnvíos">
                          Guía: {{ formatMoney(shippingCostOf(value)) }}
                        </div>
                        <div
                          class="text-xxs font-weight-bold"
                          :class="shippingCommission(value) >= 0 ? 'text-success' : 'text-danger'"
                          title="Comisión (flete - costo ConEnvíos)"
                        >
                          Dif: {{ formatMoney(shippingCommission(value)) }}
                        </div>
                      </template>
                    </td>
                    <td class="align-middle text-center">
                      <div class="d-flex flex-column align-items-center gap-1">
                        <select
                          class="form-select form-select-sm order-status-select"
                          :class="orderStatusClass(value.order_status)"
                          :value="normalizeOrderStatus(value.order_status)"
                          :disabled="updatingId === value.id"
                          @change="changeOrderStatus(value, $event)"
                        >
                          <option v-for="s in orderStatusOptions" :key="s.value" :value="s.value">
                            {{ s.label }}
                          </option>
                        </select>
                        <span v-if="value.invoice_number" class="text-xs text-secondary">
                          Fact: {{ value.invoice_number }}
                        </span>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <a
                        v-if="value.waybill_id"
                        :href="trackingUrl(value.waybill_id)"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="text-xs font-weight-bold"
                        title="Ver seguimiento en ConEnvíos"
                      >
                        {{ value.waybill_id }}
                      </a>
                      <span v-else class="text-muted text-xs">—</span>
                    </td>
                    <td class="align-middle text-center">
                      <div class="d-flex flex-column align-items-center gap-1">
                        <span class="badge badge-sm" :class="remissionStatusClass(value.status)">
                          {{ remissionStatusLabel(value.status) }}
                        </span>
                        <span
                          v-if="value.printed_at"
                          class="badge badge-sm bg-dark"
                          :title="`Impreso el ${new Date(value.printed_at).toLocaleString('es-ES')}`"
                        >
                          Impreso
                        </span>
                      </div>
                    </td>
                    <td class="align-middle text-center">
                      <select
                        class="form-select form-select-sm pauta-select"
                        :value="value.pauta || ''"
                        :disabled="updatingId === value.id"
                        @change="changePauta(value, $event)"
                      >
                        <option value=""></option>
                        <option v-for="p in pautaOptions" :key="p" :value="p">{{ p }}</option>
                      </select>
                    </td>
                    <td class="align-middle">
                      <span
                        v-if="value.observation || value.return_reason"
                        class="text-xs text-secondary cursor-pointer observation-cell"
                        :title="value.observation || value.return_reason"
                        @click="viewObservation(value)"
                      >
                        <i v-if="value.return_reason" class="fas fa-undo-alt text-danger me-1" title="Tiene motivo de devolución"></i>
                        {{ value.observation || value.return_reason }}
                      </span>
                      <i
                        v-else
                        class="fas fa-pen text-xs text-secondary cursor-pointer"
                        title="Agregar observación"
                        @click="editObservation(value)"
                      ></i>
                    </td>
                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">
                        {{ formatMoney(saleTotal(value)) }}
                      </span>
                      <div v-if="isPartiallyPaid(value)" class="text-xxs text-danger">
                        Pagado: {{ formatMoney(totalPaid(value)) }}
                      </div>
                    </td>
                    <td v-if="showSiigo" class="align-middle text-center text-sm">
                      <span
                        v-if="value.siigo_id"
                        class="badge badge-sm bg-gradient-info"
                        :title="value.siigo_id"
                      >
                        Sincronizado
                      </span>
                      <button
                        v-else-if="value.can_sync_siigo"
                        type="button"
                        class="btn btn-sm btn-outline-info py-1 px-2 mb-0"
                        :disabled="syncingId === value.id"
                        @click="syncSiigo(value)"
                      >
                        <i
                          :class="syncingId === value.id ? 'fas fa-sync fa-spin me-1' : 'fas fa-cloud-upload-alt me-1'"
                        ></i>
                        Sincronizar
                      </button>
                      <span v-else class="text-muted text-xs">—</span>
                    </td>
                    <td class="align-middle text-center text-nowrap">
                      <a
                        @click="openPicking(value)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer"
                        data-toggle="tooltip"
                        data-original-title="Picking / Packing"
                      >
                        <i class="fas fa-dolly"></i>
                      </a>

                      <a
                        @click="printRemission(value.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;"
                        data-toggle="tooltip"
                        data-original-title="Imprimir ticket"
                      >
                        <i class="fas fa-ticket-alt"></i>
                      </a>

                      <a
                        @click="viewRemission(value)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;"
                        data-toggle="tooltip"
                        data-original-title="Ver y editar pedido"
                      >
                        <i class="fas fa-eye"></i>
                      </a>

                      <a
                        v-if="normalizeRemissionStatus(value.status) !== 'aceptado'"
                        @click="deleteUser(value.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer"
                        style="margin-left: 15px;"
                        data-toggle="tooltip"
                        data-original-title="Eliminar registro"
                      >
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td :colspan="showSiigo ? 18 : 17" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>
                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer" @click="fetchData(link.url)"
                  :disabled="!link.url || link.active" :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import remissionsService from '@/services/remissions.service';
import { openPosTicketWindow } from '@/utils/posTicketPrint';
import {
  ORDER_STATUSES,
  PAUTAS,
  normalizeOrderStatus,
  orderStatusLabel,
  orderStatusClass,
} from '@/utils/orderStatuses';

// Filtros y página de la lista, para restaurarlos al volver de un pedido.
// Solo se borran con "Limpiar filtros".
const FILTERS_STORAGE_KEY = 'remissions.listFilters';

function readStoredFilters() {
  try {
    return JSON.parse(sessionStorage.getItem(FILTERS_STORAGE_KEY)) || {};
  } catch (e) {
    return {};
  }
}

// Escapa texto libre (observaciones) antes de insertarlo en el HTML de SweetAlert
function escapeHtml(value) {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function storeFilters(query) {
  try {
    sessionStorage.setItem(FILTERS_STORAGE_KEY, JSON.stringify(query));
  } catch (e) {
    // Sin almacenamiento disponible: los filtros solo viven en la URL
  }
}

export default {
  name: 'ProjectsList',
  data() {
    // Si se entra sin filtros en la URL (menú, volver de un pedido), se usan los guardados
    const routeQuery = this.$route.query || {};
    const query = Object.keys(routeQuery).length > 0 ? routeQuery : readStoredFilters();
    return {
      // Columna de Siigo oculta por ahora
      showSiigo: false,
      initialPage: parseInt(query.page, 10) || 1,
      searchQuery: query.search || '',
      orderStatusFilter: query.order_status || '',
      dateFrom: query.date_from || '',
      dateTo: query.date_to || '',
      syncingId: null,
      updatingId: null,
      orderStatusOptions: ORDER_STATUSES,
      pautaOptions: PAUTAS,
      selectedIds: [],
      generatingDispatch: false,
    };
  },
  computed: {
    ...mapGetters('remissions', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']),
    currentPage() {
      return this.$store.state.remissions.currentPage;
    },
    lastPage() {
      return this.$store.state.remissions.lastPage;
    },
    data() {
      return this.allData;
    },
    links() {
      return this.$store.getters['remissions/links'];
    },
    visibleIds() {
      return this.data.map((r) => r.id);
    },
    allSelected() {
      return this.visibleIds.length > 0 && this.visibleIds.every((id) => this.selectedIds.includes(id));
    },
    someSelected() {
      return !this.allSelected && this.visibleIds.some((id) => this.selectedIds.includes(id));
    },
  },
  methods: {
    sellerName(row) {
      if (row?.seller_name) {
        return row.seller_name;
      }
      if (row?.seller?.name) {
        return row.seller.name;
      }
      return '—';
    },
    normalizeRemissionStatus(status) {
      if (status === 0 || status === '0') {
        return 'pendiente';
      }
      if (status === 1 || status === '1') {
        return 'aceptado';
      }
      if (status === 'pendiente' || status === 'aceptado' || status === 'cancelado' || status === 'devolucion') {
        return status;
      }
      return 'aceptado';
    },
    remissionStatusLabel(status) {
      const normalized = this.normalizeRemissionStatus(status);
      if (normalized === 'aceptado') return 'Aceptado';
      if (normalized === 'cancelado') return 'Cancelado';
      if (normalized === 'devolucion') return 'Devolución';
      return 'Pendiente';
    },
    remissionStatusClass(status) {
      const normalized = this.normalizeRemissionStatus(status);
      if (normalized === 'aceptado') return 'bg-success';
      if (normalized === 'cancelado') return 'bg-danger';
      if (normalized === 'devolucion') return 'bg-danger';
      return 'bg-warning';
    },
    async fetchData(pageUrl = null) {
      let page;
      if (pageUrl) {
        try {
          page = new URL(pageUrl, window.location.origin).searchParams.get('page') || 1;
        } catch (e) {
          page = 1;
        }
      } else {
        // Tras acciones (aceptar/eliminar/sincronizar) mantenemos la página actual
        page = this.currentPage;
      }
      await this.fetchDataWithPage(page);
    },
    async fetchDataWithPage(page) {
      const params = {
        search: this.searchQuery,
        order_status: this.orderStatusFilter,
        date_from: this.dateFrom,
        date_to: this.dateTo,
        page,
      };
      await this.$store.dispatch('remissions/fetchData', params);
      this.syncRouteQuery();
    },
    applyFilters() {
      // Al cambiar búsqueda, filtro o fechas, volvemos a página 1 y refrescamos
      this.fetchDataWithPage(1);
    },
    clearFilters() {
      this.searchQuery = '';
      this.orderStatusFilter = '';
      this.dateFrom = '';
      this.dateTo = '';
      storeFilters({});
      this.fetchDataWithPage(1);
    },
    toggleSelectAll(checked) {
      if (checked) {
        const set = new Set(this.selectedIds);
        this.visibleIds.forEach((id) => set.add(id));
        this.selectedIds = Array.from(set);
      } else {
        const visible = new Set(this.visibleIds);
        this.selectedIds = this.selectedIds.filter((id) => !visible.has(id));
      }
    },
    async generateDispatchReport() {
      if (this.selectedIds.length === 0 || this.generatingDispatch) {
        return;
      }
      this.generatingDispatch = true;
      try {
        const response = await remissionsService.dispatchReport(this.selectedIds);
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const win = window.open(url, '_blank');
        if (!win) {
          // Si el navegador bloquea el popup, forzamos descarga
          const a = document.createElement('a');
          a.href = url;
          a.download = `relacion-despacho-${Date.now()}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
        setTimeout(() => window.URL.revokeObjectURL(url), 60000);
      } catch (error) {
        console.error('Error al generar relación de despacho:', error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'No se pudo generar la relación de despacho.',
        });
      } finally {
        this.generatingDispatch = false;
      }
    },
    syncRouteQuery() {
      const query = {};
      if (this.searchQuery) query.search = this.searchQuery;
      if (this.orderStatusFilter) query.order_status = this.orderStatusFilter;
      if (this.dateFrom) query.date_from = this.dateFrom;
      if (this.dateTo) query.date_to = this.dateTo;
      if (this.currentPage > 1) query.page = String(this.currentPage);
      storeFilters(query);
      const current = this.$route.query || {};
      const same = Object.keys(query).length === Object.keys(current).length
        && Object.keys(query).every((k) => String(current[k]) === String(query[k]));
      if (!same) {
        this.$router.replace({ query }).catch(() => {});
      }
    },
    normalizeOrderStatus,
    orderStatusLabel,
    orderStatusClass,
    formatDate(value) {
      return value ? new Date(value).toLocaleDateString('es-ES') : '—';
    },
    formatDateTime(value) {
      return value
        ? new Date(value).toLocaleString('es-ES', { dateStyle: 'short', timeStyle: 'short' })
        : '—';
    },
    trackingUrl(waybillId) {
      return `https://app.conenvios.com/track/${encodeURIComponent(waybillId)}`;
    },
    // Origen de la venta: primer tramo de la observación
    // (ej. "Venta registrada desde MIA (macro Chatwoot)" o "Venta POS")
    saleOrigin(row) {
      return (row?.observation || '').split(' | ')[0].trim();
    },
    async changeOrderStatus(row, event) {
      const select = event.target;
      const current = normalizeOrderStatus(row.order_status);
      const next = select.value;
      // Si se cancela el prompt, el select vuelve al estado guardado
      const revert = () => { select.value = current; };

      if (next === current) {
        return;
      }

      const payload = { order_status: next };

      if (next === 'facturado') {
        const result = await Swal.fire({
          title: 'Número de factura',
          text: 'Ingrese el número de factura para cambiar el estado a Facturado.',
          input: 'text',
          inputValue: row.invoice_number || '',
          inputPlaceholder: 'Ej: FAC-001',
          showCancelButton: true,
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          inputValidator: (value) => (!value || !value.trim() ? 'El número de factura es obligatorio' : null),
        });
        if (!result.isConfirmed) {
          revert();
          return;
        }
        payload.invoice_number = result.value.trim();
      }

      if (next === 'devolucion') {
        const result = await Swal.fire({
          title: 'Motivo de devolución',
          text: 'Ingrese el motivo para cambiar el estado a Devolución.',
          input: 'text',
          inputValue: row.return_reason || '',
          inputPlaceholder: 'Ej: Cliente no recibió',
          inputAttributes: { maxlength: 255 },
          showCancelButton: true,
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          inputValidator: (value) => (!value || !value.trim() ? 'El motivo de devolución es obligatorio' : null),
        });
        if (!result.isConfirmed) {
          revert();
          return;
        }
        payload.return_reason = result.value.trim();
      }

      await this.updateRow(row, payload, revert, 'Error al actualizar el estado de pedido');
    },
    async changePauta(row, event) {
      const select = event.target;
      const previous = row.pauta || '';
      await this.updateRow(
        row,
        { pauta: select.value || null },
        () => { select.value = previous; },
        'Error al actualizar la pauta'
      );
    },
    async updateRow(row, payload, revert, errorText) {
      this.updatingId = row.id;
      try {
        await remissionsService.updateData(row.id, payload);
        await this.fetchData();
      } catch (error) {
        console.error(errorText, error);
        revert();
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || errorText,
        });
      } finally {
        this.updatingId = null;
      }
    },
    // Observación y motivo de devolución; el lápiz abre el modal de edición
    async viewObservation(row) {
      const observation = row.observation
        ? escapeHtml(row.observation)
        : '<span class="text-secondary">No hay observaciones disponibles.</span>';
      const returnReason = row.return_reason
        ? `<div class="mt-3"><strong>Motivo de devolución:</strong><br>${escapeHtml(row.return_reason)}</div>`
        : '';
      const result = await Swal.fire({
        title: 'Observación',
        html: `<div class="text-start text-sm" style="white-space:pre-wrap;">${observation}${returnReason}</div>`,
        icon: 'info',
        showDenyButton: true,
        denyButtonText: '<i class="fas fa-pen me-1"></i> Editar',
        denyButtonColor: '#5e72e4',
        confirmButtonText: 'Aceptar',
      });
      if (result.isDenied) {
        await this.editObservation(row);
      }
    },
    async editObservation(row) {
      const isReturn = normalizeOrderStatus(row.order_status) === 'devolucion';
      const showReason = isReturn || !!row.return_reason;
      const result = await Swal.fire({
        title: `Editar observación #${row.id}`,
        html: `
          <div class="text-start">
            <label class="form-label text-sm" for="swal-observation">Observación</label>
            <textarea id="swal-observation" class="form-control" rows="4">${escapeHtml(row.observation || '')}</textarea>
            ${showReason ? `
            <label class="form-label text-sm mt-3" for="swal-return-reason">Motivo de devolución</label>
            <input id="swal-return-reason" class="form-control" maxlength="255" value="${escapeHtml(row.return_reason || '')}">
            ` : ''}
          </div>`,
        showCancelButton: true,
        confirmButtonText: 'Guardar',
        cancelButtonText: 'Cancelar',
        focusConfirm: false,
        preConfirm: () => {
          const observation = document.getElementById('swal-observation').value.trim();
          const payload = { observation: observation || null };
          if (showReason) {
            const reason = document.getElementById('swal-return-reason').value.trim();
            if (isReturn && !reason) {
              Swal.showValidationMessage('El motivo de devolución es obligatorio');
              return false;
            }
            payload.return_reason = reason || null;
          }
          return payload;
        },
      });
      if (!result.isConfirmed) {
        return;
      }
      await this.updateRow(row, result.value, () => {}, 'Error al actualizar la observación');
    },
    fleteOf(row) {
      return parseFloat(row?.flete ?? 0) || 0;
    },
    // Costo de la guía en ConEnvíos: solo existe si se generó la guía
    hasShippingCost(row) {
      return !!row?.waybill_id && row?.shipping_cost !== null && row?.shipping_cost !== undefined;
    },
    shippingCostOf(row) {
      return parseFloat(row?.shipping_cost ?? 0) || 0;
    },
    shippingCommission(row) {
      return this.fleteOf(row) - this.shippingCostOf(row);
    },
    saleTotal(row) {
      return parseFloat(row?.total ?? 0) || 0;
    },
    totalPaid(row) {
      return parseFloat(row?.total_paid ?? 0) || 0;
    },
    isPartiallyPaid(row) {
      return this.totalPaid(row) < this.saleTotal(row);
    },
    formatMoney(value) {
      return (Number(value) || 0).toLocaleString('es-ES', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("remissions/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {
            this.fetchData();
            await Swal.fire(
              'Eliminado!',
              'El registro se ha eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el registro');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    printRemission(id) {
      openPosTicketWindow(this.$router, id);
    },
    openPicking(remission) {
      if (!remission?.id) {
        return;
      }
      this.$router.push({
        name: 'Remissions Picking',
        query: { id: String(remission.id) },
      });
    },
    viewRemission(remission) {
      if (!remission?.id) {
        return;
      }
      this.$router.push({
        name: 'Remissions Create',
        query: { id: String(remission.id) },
      });
    },
    async syncSiigo(remission) {
      if (!remission?.id || this.syncingId) {
        return;
      }

      const confirm = await Swal.fire({
        title: 'Sincronizar con Siigo',
        html: `¿Enviar la venta <strong>#${remission.id}</strong> a Siigo?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Sincronizar',
        cancelButtonText: 'Cancelar',
      });

      if (!confirm.isConfirmed) {
        return;
      }

      this.syncingId = remission.id;

      try {
        const response = await remissionsService.syncSiigo(remission.id);
        await Swal.fire({
          icon: 'success',
          title: 'Sincronizado',
          text: response.data?.message || 'Venta enviada a Siigo correctamente.',
        });
        await this.fetchData();
      } catch (error) {
        const msg =
          error?.response?.data?.message ||
          error?.message ||
          'No se pudo sincronizar la venta con Siigo.';
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: msg,
        });
      } finally {
        this.syncingId = null;
      }
    },
  },
  mounted() {
    this.fetchDataWithPage(this.initialPage);
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
}

.remissions-table td,
.remissions-table th {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.order-status-select {
  min-width: 140px;
  font-size: 0.7rem;
  font-weight: 700;
  color: #fff;
  border: 0;
}

.order-status-select option {
  color: #344767;
  background: #fff;
}

.pauta-select {
  min-width: 150px;
  font-size: 0.7rem;
}

.origin-cell,
.observation-cell {
  display: inline-block;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
</style>
